export const BACKEND_URL =
  process.env.NEXT_PUBLIC_BACKEND_URL ?? 'http://localhost:1725';

export const REALTIME_WS_URL =
  process.env.NEXT_PUBLIC_REALTIME_WS_URL ??
  'ws://localhost:1725/ai/agent/realtime';
